import { Nullable, RegionsEnum } from '../../../../models';
import { CertificateSkillboxMeta } from './certificateSkillbox.model';
import { certificateMeta } from './certificateSkillbox.meta';
import { CertificateModel } from '../../certificate.model';

const MAX_NAME_HEIGHT = 288;
const MAX_COURSE_HEIGHT = 228;

export const handleCloneCertificateSkillbox = (
  _: Document,
  element: HTMLElement
): void => {
  element.style.display = 'block';

  const nameNode = element.querySelector('#certificate-name') as HTMLDivElement;
  const nameTailNode = nameNode?.querySelector('.tail') as HTMLDivElement;
  if (nameNode) {
    const nameNodeHeight = nameNode.getBoundingClientRect().height;
    if (nameNodeHeight > MAX_NAME_HEIGHT) {
      nameTailNode.style.display = `block`;
      nameNode.style.maxHeight = `${MAX_NAME_HEIGHT}px`;
    }
  }

  const courseNode = element.querySelector(
    '#certificate-course'
  ) as HTMLDivElement;
  const courseTailNode = courseNode?.querySelector('.tail') as HTMLDivElement;
  if (courseNode) {
    const courseNodeHeight = courseNode.getBoundingClientRect().height;
    if (courseNodeHeight > MAX_COURSE_HEIGHT) {
      courseTailNode.style.display = `block`;
      courseNode.style.maxHeight = `${MAX_COURSE_HEIGHT}px`;
    }
  }
};

// Время обновления мета данных на регионе ru
const ruMetaUpdateDate = new Date(2025, 6, 21);
const ruMetaUpdateDateStartOfDay = new Date(
  ruMetaUpdateDate.getFullYear(),
  ruMetaUpdateDate.getMonth(),
  ruMetaUpdateDate.getDate()
);

const isRuMetaUpdatedDate = (
  certificate: Nullable<CertificateModel>
): boolean => {
  if (!certificate) {
    return true;
  }
  const createdAtDate = new Date(certificate.createdAt);
  const createdAtDateStartOfDay = new Date(
    createdAtDate.getFullYear(),
    createdAtDate.getMonth(),
    createdAtDate.getDate()
  );

  return (
    createdAtDateStartOfDay.getTime() >= ruMetaUpdateDateStartOfDay.getTime()
  );
};

export const getMeta = (
  certificate: Nullable<CertificateModel>,
  region: string
): CertificateSkillboxMeta => {
  switch (region) {
    case RegionsEnum.ru:
      switch (true) {
        case isRuMetaUpdatedDate(certificate):
          return certificateMeta[`${region}_v2`];
        default:
          return certificateMeta[region];
      }
    default:
      return certificateMeta[region as string];
  }
};
